import React from "react";
import { Box } from "@mui/material";
import StepperControls from "@components/StepperControls/StepperControls";
import type { SubmitState } from "@services/drybulkCargoOperationsApi";
import { useSubmitOperationFlow } from "../hooks/useSubmitOperationFlow";

interface RejectedActionsProps {
  operationId: string;
  /** The status the server returned, compared and never derived. */
  status: string | null;
  onBack: () => void;
  onSubmitted?: (state: SubmitState) => void;
  /** The host pauses its polling while the variance dialog is open. */
  onDialogOpenChange?: (open: boolean) => void;
}

/**
 * DBCO-0036 - the Shipping Agent's bar on a Rejected operation: Back and Submit (the resubmit, R-36). Submit is the same
 * flow as a Draft's: fresh precheck, the variance dialog when Remained is not 0, then submit.
 */
const RejectedActions: React.FC<RejectedActionsProps> = ({
  operationId,
  status,
  onBack,
  onSubmitted,
  onDialogOpenChange,
}) => {
  const flow = useSubmitOperationFlow({ operationId, status, onDialogOpenChange, onSubmitted });
  return (
    <Box data-testid="drybulk-cargo-operation-actions">
      <StepperControls
        prev={onBack}
        backLabelTranslationKey="common.back"
        complete={flow.canSubmit ? flow.onSubmit : undefined}
        completePending={flow.pending}
        completeLabelTranslationKey="stepper-controls.submit"
      />
      {flow.dialog}
    </Box>
  );
};

export default RejectedActions;
